import { Navigate } from '@sorare/routing';
import { ANY_SPORT_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const MarketWildcardPage = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MARKET)}
      replace
      keepParams
    />
  );
};
export default MarketWildcardPage;
